import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "./context/LangContext";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import BrandsMarquee from "./components/BrandsMarquee";
import Inspiration from "./components/Inspiration";
import Requirements from "./components/Requirements";
import HowItWorks from "./components/HowItWorks";
import ApplicationForm from "./components/ApplicationForm";
import Footer from "./components/Footer";
import { AdminLogin, AdminDashboard } from "./components/Admin";

const Home = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <BrandsMarquee />
      <Inspiration />
      <Requirements />
      <HowItWorks />
      <ApplicationForm />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
